import React, { useState } from "react";
import Navbar from "../components/GeneralComponents/Navbar";
import SideNav from "../components/GeneralComponents/SideNav";
import * as Yup from "yup";
import { Formik, Field, Form, ErrorMessage } from "formik";
import TextError from "../helper/TextError";
import authAPI from "../api/auth";
import Button from "../components/GeneralComponents/Button";
import { toast } from "react-hot-toast";
import { getServerError, routes } from "../helper/misc";
import { useNavigate } from "react-router-dom";

function DataDeletionRequest(props) {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const initialValues = {
    email: "",
    reason: "",
  };

  const validationSchema = Yup.object({
    email: Yup.string()
      .email("Invalid Email Format!")
      .required("Email is Required!"),
    reason: Yup.string(),
  });

  const onSubmit = async (values) => {
    setLoading(true);
    try {
      const { data } = await authAPI.deleteDataRequest({
        email: values.email,
        reason: values.reason,
      });
      setLoading(false);
      toast.success(data.message);
      navigate(routes.home);
    } catch (e) {
      toast.error(getServerError(e));
      setLoading(false);
    }
  };

  return (
    <>
      <div className="grid grid-cols-1 lg:grid-cols-4">
        <SideNav className={"!static"} />
        <div className="col-span-1 lg:col-span-3">
          <Navbar />
          <div className="bg-[#F3F5F9] lg:mt-[-2rem] border rounded-3xl h-screen lg:mx-auto pb-20 lg:scale-[80%]">
            <h2 className="pt-10 lg:pt-20 font-semibold text-3xl text-center">
              Data Deletion Request
            </h2>
            <div className="mt-6 md:mt-8 lg:mt-16">
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
              >
                {(formik) => (
                  <Form className="flex flex-col justify-center items-center">
                    <Field
                      type="email"
                      name="email"
                      id="email"
                      placeholder="Enter Email"
                      className="w-80 md:w-[450px] outline-pw-blue pl-8 py-2 border border-2 rounded-2xl bg-gray-100"
                    />
                    <ErrorMessage name="email" component={TextError} />
                    <Field
                      as="textarea"
                      name="reason"
                      id="reason"
                      placeholder="Reason (optional)"
                      className="w-80 md:w-[450px] outline-pw-blue pl-8 py-2 border border-2 rounded-2xl bg-gray-100 mt-8 h-24"
                    />
                    <ErrorMessage name="reason" component={TextError} />
                    <Button type="submit" loading={loading} text="Continue" />
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DataDeletionRequest;
